import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { oidcConfig } from './authentication/config';
import { GuardianProvider } from './authentication/GuardianProvider';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <GuardianProvider>
        <App />
      </GuardianProvider>
    </AuthProvider>
  </React.StrictMode>
);
